import React, {useContext, useState} from "react";

import styles from "./UIModalReportPost.module.scss";
import {useTranslation} from "react-i18next";
//@ts-ignore
import _ from "lodash";

import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {checkEmpty} from "src/service/util.service";
import {AppContext} from "src/pages/context/App.context";
import useFetch, {CachePolicies} from "use-http";
import {Modal} from "antd";
import ButtonCenterCLose from "src/components/shared/button/CloseButton/ButtonCenterClose";
import CenterButton from "src/components/shared/button/CenterButton";

const ReportPostIssues = {
  NotInterest: "I'm not interested in the post",
  Spam: "It's suspicious or spam",
  Sensitive: "It displays as sensitive photo or video",
  Harmful: "It's abusive or harmful",
  Suicide: "It expresses intentions of self-harm or suicide",
  Illegal: "It's illegal",
};

function UIModalReportPost(props: any) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading]: any = useState(false);
  const [messageNoti, setMessageNoti]: any = useState("");
  const [issue, setIssue]: any = useState(null);
  const [reason, setReason]: any = useState(null);
  const appcontext: any = useContext(AppContext);
  const { onClose, friend, onRefresh, onCloseProfilePopup } = props;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#FFFFFF" }} spin />
  );

  const apiReport = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/create`,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const fnDone = async () => {
    let data = {
      refID: props?.id,
      reportReason: reason,
      reportTopic: issue,
      reportType: "post",
    };
    const res = await apiReport.post("", data);
    setIssue("")
    onClose();
  };

  return (
    <Modal
      centered
      open={props.show}
      className={styles.modalOveride}
      onCancel={() => {
        setIssue("")
        onClose();
      }}
    >
      <div
        onClick={() => {
          setIssue("")
          onClose();
        }}
        className={styles.closeBtn}
        // style={{ backgroundImage: `url(${crossIcon})` }}
      ><ButtonCenterCLose/></div>
      <div style={{ width: "100%" }}>
        <div className={styles.reportHeader}>{t("Report post")}</div>
        {checkEmpty(issue) && (
          <div className={styles.boxSelectIssue}>



            {Object.values(ReportPostIssues).map((val: any) => {
              return (<div
                key={val}
                className={styles.issueItem}
                onClick={() => {
                  setIssue(val);
                }}
              >
                {t(val)}
              </div>)
            })}

          </div>
        )}
        {!checkEmpty(issue) && (
          <div
            style={{
              paddingTop: "20px",
            }}
          >
            <div style={{ display: "flex" }}>
              <div className={styles.textTitleIssue}>{t("Issue") + " :"}</div>
              <div>&nbsp;{t(issue)}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div className={styles.textTitleIssue}>{t("Reason") + " : "}</div>
            </div>
            <div>
              <textarea
                className={styles.reasontext}
                rows={4}
                cols={12}
                onChange={(e) => {
                  setReason(e.target.value)
                }}
              ></textarea>
            </div>
            <div>
              <CenterButton>
              <div onClick={fnDone}>
                  {apiReport.loading ? <Spin indicator={antIcon} /> : t("Submit")}
                </div>
              </CenterButton>
              {/* <button
                className={styles.bottonBtnOk}
                style={{ fontSize: "1.2rem", marginTop: "39px" }}
              >
                <div onClick={fnDone}>
                  {apiReport.loading ? <Spin indicator={antIcon} /> : t("Submit")}
                </div>
              </button> */}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default UIModalReportPost;
